import { responsiveConstant } from '@app/Dashboard/constants';
import MobileLibrary from './components/MobileLibrary';
import WebLibrary from './components/WebLibrary';

const Library = () => {
  const width = window.innerWidth;

  return (
    <div>{width > responsiveConstant ? <WebLibrary /> : <MobileLibrary />}</div>
  );
};

export default Library;
